<template>
    <v-layout align-start>
        <v-flex>
             <v-data-table
                :headers="headers"
                :items="grupos"
                :search="search"
                class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Grupos</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" 
                        v-model="search" append-icon="search" 
                        label="Busqueda" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- ********** -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Crear grupo</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Grupos</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn dark text @click="newItem">Limpiar Controles</v-btn>
                                </v-toolbar-items>
                                <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn 
                                        @click="saveItem"
                                        dark text>
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>                        
                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-autocomplete
                                                v-model="editedItem.idUsuario"
                                                :items="catUsuarios"
                                                :filter="customFilter"
                                                color="white"
                                                item-text="nombre"
                                                item-value="idUsuario"
                                                label="Administrador"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                            <v-text-field
                                                label="Nombre"
                                                v-model="editedItem.nombre"
                                                outlined>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
                    <!-- ********** -->
                    </v-toolbar>
                </template>
                
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td>
                                <div>
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        edit
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        delete
                                    </v-icon>
                                </div>
                            </td>
                            <td>{{ item.nombre }}</td>
                            <td>{{ item.fechaCreacion | formatDate }}</td>
                            <td>
                                 <div v-if="item.vigencia" @click="estatus(item)">
                                    <v-btn class="green--text" text >Activo</v-btn>
                                </div>
                                <div v-else @click="estatus(item)">
                                    <v-btn class="red--text" text >Inactivo</v-btn>
                                </div>
                                <!-- <v-icon class="mr-2">
                                    {{ item.vigencia ? 'done_outline' : 'highlight_off' }}
                                </v-icon> -->
                            </td>
                        </tr>
                    </tbody>
                </template> 
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Resetear</v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import moment from 'moment'
export default {
    components: {
    },
    data() {
        return {
            grupos:[],
            catUsuarios: [],

            editedItem: {},
            dialogFecha: false,

            consultaDto: {
                Skip: 0,
                Take: 100,
                descending: true,
                sortBy: '',
                search: ''
            },

            dialog: false,
            headers: [
                { text: ' ', value: ' ' },
                { text: 'Nombre', value: 'Nombre' },
                { text: 'Fecha Creacion', value: 'FechaCreacion' },
                { text: 'Vigencia', value: 'vigencia' }            
            ],
            rulesIMG: [
                value => !value || value.size < 2000000 || 'La imagen no puede ser mayor de 2 MB!',
            ],
            rulesPDF: [
                value => !value || value.size < 2000000 || 'El PDF no puede ser mayor de 2 MB!',
            ],
            files: null,
            search: '',
        }
    },
    computed: { },
    watch: { },
    created () { },
    mounted () {
        this.Default()
    },
    filters: {
        formatDate(date){
            return moment(date).format('L')
        }
    },
    methods: {
        Default () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Grupos/Get')
                .then(r => {
                    if (r.data.exito) {
                        me.grupos = r.data.datos
                        me.newItem()
                    }
                })
                .catch(e => { console.log(e) })
            me.$axios.post('api/Usuario/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.catUsuarios = r.data.datos
                    }
                    // this.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
        },
        customFilter (item, queryText, itemText) {
            const textOne = item.nombre.toLowerCase()
            const searchText = queryText.toLowerCase()
            let r = textOne.indexOf(searchText) > -1 
            return r
        },
            
        newItem () {
            let me = this
            me.$axios.get('api/Grupos/New')
                .then(r => {
                    me.editedItem = r.data
                })
                .catch(e => { console.log(e) })
        },
        editItem (item) {
            this.editedItem = item
            this.dialog = true
        },
        estatus (item) {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Grupos/Estatus?IdGrupo=' + item.idGrupo)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Estatus actualizado')
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.Default();
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => {                     
                    this.$root.Mensaje(e.data.mensaje)
                })
         },
         deleteItem (item) {
            debugger
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.$axios.get('api/Grupos/Delete?Id=' + item.idGrupo)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Registro eliminado')
                        me.Default();
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => {                     
                    this.$root.Mensaje(e)
                })
        },
        saveItem () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            var js = {
                "IdGrupo": me.editedItem.idGrupo,
                "IdUsuario": me.editedItem.idUsuario,
                "Nombre": me.editedItem.nombre,
                "Tipo": me.editedItem.tipo,
                "Vigencia": me.editedItem.vigencia,
                "FechaCreacion": me.$moment(me.editedItem.fechaCreacion).format("YYYY-MM-DD")
            }
            console.log(js)
            me.$axios.post('api/Grupos/Save', js)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Grupo creado')
                      
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.Default();
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => { this.$root.Mensaje(e.data.mensaje) })
        }
    }
}
</script>
